import { motion } from "framer-motion";
import { Lotus } from "./Lotus";

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl`}>
    <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
      <span className="w-8 h-px bg-[#b89d62]/60" />
      <Lotus className="w-7 h-5 text-[#b89d62]" />
      <span className="w-8 h-px bg-[#b89d62]/60" />
    </div>
    <p className="eyebrow mt-5">{eyebrow}</p>
    <h2
      className={`font-serif-display font-light text-4xl sm:text-5xl mt-3 tracking-tight ${
        light ? "text-[#151c0f]" : "text-[#faf9f6]"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p
        className={`mt-5 text-base font-light leading-relaxed ${
          light ? "text-[#4a5340]" : "text-[#c9d3ca]"
        }`}
      >
        {subtitle}
      </p>
    )}
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
